import React, { useEffect, useState } from 'react';
import nodeLogos from 'src/utils/nodeLogos';
import { LinkControlPanelInputForm } from './link-input-form';
import { Block, ClipboardContentType } from '../types';
import { useClipboardStore } from '../utils/clipboard.store';
import { shallow } from 'zustand/shallow';
import { EmbedCheckResponse } from './types';

type Props = {
  onNewUrl: (url: string, title: string, checkResponse?: EmbedCheckResponse) => void;
  isIntegration?: boolean;
  clipboardData?: ClipboardContentType;
  integrationType?: string;
};

type LOGO_HOST =
  | 'loom'
  | 'calendly'
  | 'google_slides'
  | 'figma'
  | 'youtube'
  | 'google_sheets'
  | 'pitch'
  | 'vimeo'
  | 'google_forms'
  | 'typeform'
  | 'google_docs';
const LOGO_HOSTS: LOGO_HOST[] = [
  'loom',
  'calendly',
  'figma',
  'youtube',
  'google_slides',
  'google_sheets',
  'pitch',
  'vimeo',
  'google_forms',
  'typeform',
  'google_docs',
];

export const AddLinkControlPanelContent = ({ onNewUrl, isIntegration, integrationType }: Props) => {
  const [randomLogos, setRandomLogos] = useState<LOGO_HOST[]>([]);
  const currentClipboardData = useClipboardStore((state) => state.currentClipboardData, shallow);
  const clipboardAutoGenerate = useClipboardStore((state) => state.autoGenerate, shallow);
  const revokeAutoGenerate = useClipboardStore((state) => state.revokeAutoGenerate);

  useEffect(() => {
    // get 4 random logos
    const shuffledLogos = LOGO_HOSTS.sort(() => Math.random() - 0.5);
    setRandomLogos(shuffledLogos.slice(0, 4));
  }, []);

  const placeholder = integrationType === 'notion' ? 'Paste your URL / iframe code' : 'Paste your URL';

  return (
    <div className='flex flex-col space-y-4'>
      <LinkControlPanelInputForm
        url={currentClipboardData?.url || ''}
        isUrlFromClipboard={!!currentClipboardData && clipboardAutoGenerate}
        onNewUrl={(url) => onNewUrl(url, '', currentClipboardData?.embedCheckResponse)}
        onSubmitClipboardForm={revokeAutoGenerate}
        placeholder={placeholder}
        autoFocus
        isNotionIntegration={integrationType === 'notion'}
      />
      {!isIntegration && (
        <div className='flex items-center space-x-4'>
          <div className='text-neue-journey-small text-neue-journey-fg'>Display anything</div>
          {randomLogos.map((host: LOGO_HOST) => {
            const HostLogo = nodeLogos[host];
            if (!HostLogo) return null;

            return <HostLogo className='h-4 w-auto' />;
          })}
        </div>
      )}
    </div>
  );
};
